import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaSignInAlt } from "react-icons/fa";
// import { FaUserPlus } from "react-icons/fa";
import { Icon } from "../common/Icon";

const LoginRegisterButtons: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Tasarımı tam kontrol altına almak için temel stil objesi
  const buttonBaseStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    height: "36px", // Dil dropdown'u ile uyumlu olması için 36px-38px idealdir
    padding: "0 16px",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    borderRadius: "100px", // Tam yuvarlak
    cursor: "pointer",
    outline: "none",
    textDecoration: "none",
    boxSizing: "border-box", // Border dahil yükseklik hesaplama
    margin: 0,
    lineHeight: 1,
  };

  const loginButtonStyle: React.CSSProperties = {
    ...buttonBaseStyle,
    backgroundColor: "transparent",
    border: "1px solid #e2e8f0",
    color: "#475569",
  };

  /* Self-service registration is disabled; users are created by admins.
  const registerButtonStyle: React.CSSProperties = {
    ...buttonBaseStyle,
    backgroundColor: "#0d6efd",
    border: "1px solid #0d6efd", // Aynı yükseklik için border ekledik
    color: "#ffffff",
    boxShadow: "0 2px 4px rgba(13, 110, 253, 0.1)",
  };
  */

  return (
    <div 
      className="d-flex align-items-center gap-2" 
      style={{ 
        height: "100%", // Navbar içindeki dikey hizalamayı garantiler
        display: "flex", 
        alignItems: "center" 
      }}
    >
      {/* Login Butonu */}
      <button
        style={loginButtonStyle}
        onClick={() => navigate("/login")}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#f8fafc";
          e.currentTarget.style.borderColor = "#cbd5e1";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div 
          className="d-flex align-items-center justify-content-center bg-primary-subtle rounded-circle" 
          style={{ width: "20px", height: "20px", flexShrink: 0 }}
        >
          <Icon icon={FaSignInAlt} size={10} className="text-primary" />
        </div>
        <span>{t("login")}</span>
      </button>

      {/* Register button disabled; users are created by admins.
      <button
        style={registerButtonStyle}
        onClick={() => navigate("/register")}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#0b5ed7";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#0d6efd";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <Icon icon={FaUserPlus} size={13} color="#ffffff" className="flex-shrink-0" />
        <span>{t("register")}</span>
      </button>
      */}
    </div>
  );
};

export default LoginRegisterButtons;
